import {configureStore} from '@reduxjs/toolkit'
import {Stories,
    Users, Auth,
    Orders, Notifications,
    Authors, Analytics3d, OrdersTime, CustomerHistory,
    Mockups, MockupsStats, MockupsCustomers, MockupsCompareStats, StoryTags, RemovebgLogs, ModelFrontLogs, HealthCheck, SessionConversion, Theme, AavOrders, CustomerFormSubmissions, MockupGenerationLogs, PrintFileJobs} from './slices';
import * as middlewares from './middlewares';


const store = configureStore({
    reducer: {
        auth: Auth.reducer,
        stories: Stories.reducer,
        storyTags: StoryTags.reducer,
        orders: Orders.reducer,
        users: Users.reducer,
        notifications: Notifications.reducer,
        authors: Authors.reducer,
        analytics3d: Analytics3d.reducer,
        ordersTime: OrdersTime.reducer,
        customerHistory: CustomerHistory.reducer,
        mockups: Mockups.reducer,
        mockupsStats: MockupsStats.reducer,
        mockupsCustomers: MockupsCustomers.reducer,
        mockupsCompareStats: MockupsCompareStats.reducer,
        removebgLogs: RemovebgLogs.reducer,
        modelFrontLogs: ModelFrontLogs.reducer,
        healthCheck: HealthCheck.reducer,
        sessionConversion: SessionConversion.reducer,
        aavOrders: AavOrders.reducer,
        customerFormSubmissions: CustomerFormSubmissions.reducer,
        mockupGenerationLogs: MockupGenerationLogs.reducer,
        printFileJobs: PrintFileJobs.reducer,
        theme: Theme.default,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(middlewares.auth)
            .concat(middlewares.stories)
            .concat(middlewares.storyTags)
            .concat(middlewares.orders)
            .concat(middlewares.users)
            .concat(middlewares.authors)
            .concat(middlewares.analytics3d)
            .concat(middlewares.ordersTime)
            .concat(middlewares.customerHistory)
            .concat(middlewares.mockups)
            .concat(middlewares.mockupsCustomers)
            .concat(middlewares.mockupsStats)
            .concat(middlewares.mockupsCompareStats)
        .concat(middlewares.aavOrders)
        .concat(middlewares.customerFormSubmissions)
})

export default store;
